// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FffJ","toggleWrap":"styles_toggleWrap__1C36v","content":"styles_content__Zs4uh","selectAreaCode":"styles_selectAreaCode__2TGAi"};